// What more than one portal screen needs to agree on. Kept out of PortalApp.js
// so no screen imports the module that imports it.

import { day } from './portalApi';

/** Money is shown only to a contact with billing access at some client (docs/CLIENT_PORTAL.md §4). */
export function hasBilling(me) {
  return !!(me && Array.isArray(me.clients) && me.clients.some((c) => c.access === 'billing'));
}

/** An invoice's state, in words and a tone — never colour alone (docs/APP_REBUILD.md §3.3). */
export function invoiceState(r) {
  if (r.status === 'paid' || r.balance_cents === 0) return { label: 'Paid', tone: 'ok' };
  if (r.days_overdue > 0) return { label: `Overdue ${r.days_overdue} day${r.days_overdue === 1 ? '' : 's'}`, tone: 'stop' };
  if (r.paid_cents > 0) return { label: 'Part paid', tone: 'warn' };
  return { label: r.due_on ? `Due ${day(r.due_on)}` : 'Open', tone: 'sched' };
}

/** An estimate's state as the client reads it. */
export function estimateState(status) {
  if (status === 'accepted') return { label: 'Accepted', tone: 'ok' };
  if (status === 'declined') return { label: 'Declined', tone: 'neutral' };
  if (status === 'expired') return { label: 'Expired', tone: 'neutral' };
  return { label: 'Waiting for you', tone: 'sched' };
}

// Both open the document's own public page — the page and PDF the email links
// to, with Pay (invoices) or Accept / Decline (estimates). The portal adds no
// second way to pay.
// A row with no token has no page to open: encodeURIComponent(null) is the
// string "null", which would open /invoice/null and a 404 (review of #724;
// routes/invoices.js guards the same field).
export const invoiceHref = (r) => (r && r.access_token ? `/invoice/${encodeURIComponent(r.access_token)}` : null);
export const estimateHref = (r) => (r && r.access_token ? `/estimate/${encodeURIComponent(r.access_token)}` : null);
export const openInvoice = (r) => { const href = invoiceHref(r); if (href) window.location.assign(href); };
export const openEstimate = (r) => { const href = estimateHref(r); if (href) window.location.assign(href); };
